// /* ─────────────────────────────────────────────
//    Constants
// ───────────────────────────────────────────── */
// const WISHLIST_URL  = `https://dstugwafahsxviiqnceu.supabase.co/functions/v1/add-product-in-wishlist`;
// const CACHE_KEY     = 'wishlist_ids';
// var WISH_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRzdHVnd2FmYWhzeHZpaXFuY2V1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIxNjI5MzAsImV4cCI6MjA3NzczODkzMH0.9Sm1DjC5rZ6vQZGccPbVJUfKSKIvxe0UGgEFz6gRHr8';

// const ICON = {
//   active:   `<i class="fa-solid fa-heart wishlist-heart-icon"   aria-hidden="true"></i>`,
//   inactive: `<i class="fa-regular fa-heart wishlist-heart-icon"  aria-hidden="true"></i>`,
//   loading:  `<i class="fa-solid fa-spinner fa-spin wishlist-heart-icon" aria-hidden="true"></i>`,
// };

// // const ICON = {
// //   active: `<svg viewBox="0 0 24 24" width="23" height="23" fill="red" style="display:block;">
// //     <path d="M12 21s-6.7-4.35-9.3-8.2C.8 9.9 1.4 6.2 4.6 4.6c2.3-1.15 4.8-.4 6.4 1.4l1 1.1 1-1.1c1.6-1.8 4.1-2.55 6.4-1.4 3.2 1.6 3.8 5.3 1.9 8.2C18.7 16.65 12 21 12 21z"/>
// //   </svg>`,

// //   inactive: `<svg viewBox="0 0 24 24" width="23" height="23" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:block;">
// //     <path d="M12 21s-6.7-4.35-9.3-8.2C.8 9.9 1.4 6.2 4.6 4.6c2.3-1.15 4.8-.4 6.4 1.4l1 1.1 1-1.1c1.6-1.8 4.1-2.55 6.4-1.4 3.2 1.6 3.8 5.3 1.9 8.2C18.7 16.65 12 21 12 21z"/>
// //   </svg>`,

// //   loading: `<svg viewBox="0 0 50 50" width="23" height="23" style="display:block;animation:wishlist-spin 0.8s linear infinite;">
// //     <circle cx="25" cy="25" r="20" fill="none" stroke="red" stroke-width="5" stroke-linecap="round" stroke-dasharray="90 60"></circle>
// //   </svg>`,
// // };

// /* ─────────────────────────────────────────────
//    State
// ───────────────────────────────────────────── */
// let wishlistIds       = [];
// const processingBtns  = new WeakSet(); // debounce: prevent double-clicks

// /* ─────────────────────────────────────────────
//    Cache helpers
// ───────────────────────────────────────────── */
// function saveCache() {
//   try { localStorage.setItem(CACHE_KEY, JSON.stringify(wishlistIds)); } catch (_) {}
// }

// function loadCache() {
//   try {
//     const raw = localStorage.getItem(CACHE_KEY);
//     if (raw) wishlistIds = JSON.parse(raw);
//   } catch (_) {
//     wishlistIds = [];
//   }
// }

// /* ─────────────────────────────────────────────
//    API helper  — single source of truth for fetch config
// ───────────────────────────────────────────── */
// async function wishlistFetch(body) {
//   const res = await fetch(WISHLIST_URL, {
//     method:  'POST',
//     headers: { 
//       'Content-Type': 'application/json', 
//       'Accept': 'application/json',
//       'apikey': WISH_KEY, 'Authorization': 'Bearer ' + WISH_KEY 
//      },
//     body:    JSON.stringify(body),
//   });
//   const data = await res.json();
//   if (!res.ok) throw new Error(data?.message || 'Something went wrong');
//   return data;
// }

// /* ─────────────────────────────────────────────
//    Product data helper
// ───────────────────────────────────────────── */
// function getProductFromBtn(btn) {
//   return {
//     id:     btn.dataset.productId    || '',
//     title:  btn.dataset.productTitle || '',
//     handle: btn.dataset.productHandle|| '',
//     image:  btn.dataset.productImage || '',
//     size:   btn.dataset.productSize  || '',
//   };
// }

// /* ─────────────────────────────────────────────
//    Wishlist count badge
// ───────────────────────────────────────────── */
// function updateWishlistCount(count) {
//   const el = document.getElementById('wishlist-count');
//   if (el) el.textContent = Math.max(0, count);
// }

// /* ─────────────────────────────────────────────
//    Mark all heart buttons active / inactive
// ───────────────────────────────────────────── */
// function markWishlist() {
//   const set = new Set(wishlistIds.map(String));

//   document.querySelectorAll('.wishlist-btn').forEach(btn => {
//     if (btn.classList.contains('wishlist-cartitem')) return;
//     btn.innerHTML = set.has(String(btn.dataset.productId))
//       ? ICON.active
//       : ICON.inactive;
//   });

//   updateWishlistCount(set.size);
// }

// /* ─────────────────────────────────────────────
//    Load wishlist  (cache-first, then server)
// ───────────────────────────────────────────── */
// async function loadWishlist() {
//   if (!window.customerId) { markWishlist(); return; }

//   // Step 1 — instant render from cache
//   loadCache();
//   markWishlist();

//   // Step 2 — sync with server
//   try {
//     const data      = await wishlistFetch({ customer_id: window.customerId });
//     const serverIds = (data.wishlistProducts?.data || []).map(p => String(p.product_id));

//     // Only re-render if the lists actually differ (use copies to avoid mutating originals)
//     const serverSorted  = [...serverIds].sort();
//     const cachedSorted  = [...wishlistIds].sort();

//     if (JSON.stringify(serverSorted) !== JSON.stringify(cachedSorted)) {
//       wishlistIds = serverIds;
//       saveCache();
//       markWishlist();
//     }
//   } catch (err) {
//     console.error('Wishlist load error:', err);
//   }
// }

// /* ─────────────────────────────────────────────
//    Sync wishlist state (add / remove ID)
// ───────────────────────────────────────────── */
// function syncLocalState(productId, removing) {
//   if (removing) {
//     wishlistIds = wishlistIds.filter(id => id !== String(productId));
//   } else if (!wishlistIds.includes(String(productId))) {
//     wishlistIds.push(String(productId));
//   }
//   saveCache();
//   updateWishlistCount(wishlistIds.length);
// }

// /* ─────────────────────────────────────────────
//    Wish counts (public, per-product — how many
//    customers in total have wishlisted a product)

//    Rendered via the data-wishlist-count attribute
//    on .wishlist-btn itself (CSS shows it with
//    ::after { content: attr(data-wishlist-count) }),
//    NOT as a child element — so it survives the
//    innerHTML swaps in markWishlist()/click handler.
// ───────────────────────────────────────────── */
// const wishCounts = {}; // productId (string) -> count

// // Push cached counts onto every matching .wishlist-btn currently in the DOM
// function applyWishCounts() {
//   document.querySelectorAll('.wishlist-btn[data-product-id]').forEach(btn => {
//     const id    = btn.dataset.productId;
//     const count = wishCounts[id] || 0;
//     btn.dataset.wishlistCount = count > 0 ? count : '';
//   });
// }

// // Adjust a cached count immediately (optimistic UI) without waiting on a refetch
// function bumpWishCount(productId, delta) {
//   const id      = String(productId);
//   const current = wishCounts[id] ?? 0;
//   const next    = Math.max(0, current + delta);
//   wishCounts[id] = next;

//   document
//     .querySelectorAll(`.wishlist-btn[data-product-id="${id}"]`)
//     .forEach(btn => { btn.dataset.wishlistCount = next > 0 ? next : ''; });
// }

// // Edge function's GET method returns ALL product counts in one call:
// // { success: true, data: [{ product_id, product_count }, ...] }
// async function loadWishCounts() {
//   try {
//     const res  = await fetch(WISHLIST_URL, {
//       method:  'GET',
//       headers: {
//          'Accept': 'application/json',
//          'apikey': WISH_KEY, 'Authorization': 'Bearer ' + WISH_KEY 
//          },
//     });
//     const data = await res.json();
//     if (!res.ok) throw new Error(data?.message || 'Something went wrong');

//     (data.data || []).forEach(row => {
//       wishCounts[String(row.product_id)] = Number(row.product_count) || 0;
//     });

//     applyWishCounts();
//   } catch (err) {
//     console.error('Wish counts load error:', err);
//   }
// }

// /* ─────────────────────────────────────────────
//    Wishlist page: animate & remove card
// ───────────────────────────────────────────── */
// function removeCardFromWishlistPage(btn) {
//   if (btn.closest('.wl-matches-grid')) return;
//   const isWishlistPage =
//     document.querySelector('.wishlist-page') ||
//     document.querySelector('[id^="wishlist-section-"]');

//   if (!isWishlistPage) return;

//   const card = btn.closest('.product-card');
//   if (!card) return;

//   card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
//   card.style.opacity    = '0';
//   card.style.transform  = 'scale(0.95)';

//   setTimeout(() => {
//     card.remove();

//     const grid = document.querySelector('[id^="wishlist-collection-"]');
//     if (grid && grid.querySelectorAll('.product-card').length === 0) {
//       grid.style.display = 'none';
//       const empty = document.querySelector('[id^="wishlist-empty-"]');
//       if (empty) empty.style.display = '';
//     }
//   }, 300);
// }

// /* ─────────────────────────────────────────────
//    Cart item: move-to-wishlist flow
// ───────────────────────────────────────────── */
// async function removeFromCart(btn, product) {
//   const cartLineItem = btn.closest('li');
//   const removeLink   = cartLineItem?.querySelector('.remove-from-cart-link');

//   if (removeLink) {
//     // Theme has a native remove link — show message, then click it
//     const removedMsg = cartLineItem?.querySelector('.removed');
//     const msgText    = cartLineItem?.querySelector('.removed-msg-text');

//     if (removedMsg && msgText) {
//       msgText.textContent    = `"${product.title}" moved to Wishlist`;
//       removedMsg.style.display = 'block';
//     }

//     setTimeout(() => removeLink.click(), 600);
//     return;
//   }

//   // Fallback: remove via /cart/change.js (returns updated cart — no second fetch needed)
//   try {
//     const cartData = await fetch('/cart.js').then(r => r.json());
//     const cartItem = cartData.items.find(item => String(item.product_id) === String(product.id));

//     if (cartItem) {
//       const updatedCart = await fetch('/cart/change.js', {
//         method:  'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body:    JSON.stringify({ id: cartItem.key, quantity: 0 }),
//       }).then(r => r.json());

//       document.dispatchEvent(new CustomEvent('cart:refresh'));

//       document
//         .querySelectorAll('[data-cart-count], .cart-count, #cart-count, [data-totalqty]')
//         .forEach(el => el.textContent = updatedCart.item_count);
//     }
//   } catch (err) {
//     console.error('Cart remove error:', err);
//   }
// }

// /* ─────────────────────────────────────────────
//    Main click handler — wishlist buttons
// ───────────────────────────────────────────── */
// document.addEventListener('click', async (e) => {
//   const btn = e.target.closest('.wishlist-btn');
//   if (!btn) return;

//   e.preventDefault();
//   e.stopPropagation();

//   // Auth guard
//   if (!window.customerId) {
//     window.location.href = `/account/login?return_url=https://account.circledrops.co`;
//     return;
//   }

//   // Debounce: ignore while a request is in flight
//   if (processingBtns.has(btn)) return;

//   // Cart-item confirmation tooltip (first click = confirm, second click = proceed)
//   if (btn.classList.contains('wishlist-cartitem')) {
//     if (btn.dataset.confirmed !== 'true') {
//       showTooltip(btn);
//       btn.dataset.confirmed = 'true';
//       setTimeout(() => { btn.dataset.confirmed = 'false'; removeTooltip(btn); }, 3000);
//       return;
//     }
//     removeTooltip(btn);
//     btn.dataset.confirmed = 'false';
//   }

//   // Capture state before we replace the icon
//   const isRemoving = btn.querySelector('i')?.classList.contains('fa-solid');
//   const product    = getProductFromBtn(btn);

//   btn.innerHTML = ICON.loading;
//   processingBtns.add(btn);

//   try {
//     const data = await wishlistFetch({
//       customer_id: window.customerId,
//       product,
//       flag: isRemoving,
//     });

//     if (!data.success) throw new Error('Unexpected response from server');

//     btn.innerHTML = isRemoving ? ICON.inactive : ICON.active;
//     syncLocalState(product.id, isRemoving);

//     // Optimistically update the visible wish count for this product
//     bumpWishCount(product.id, isRemoving ? -1 : 1);

//     if (isRemoving) {
//       removeCardFromWishlistPage(btn);
//     } else {
//       await removeFromCart(btn, product);
//     }

//   } catch (err) {
//     // Restore previous icon on error
//     btn.innerHTML = isRemoving ? ICON.active : ICON.inactive;
//     showErrorToast(err.message || 'Could not update wishlist');
//     console.error('Wishlist error:', err);
//   } finally {
//     processingBtns.delete(btn);
//   }
// });

// /* ─────────────────────────────────────────────
//    Auto-remove from wishlist when added to cart
//    (click-level interception as a backup)
// ───────────────────────────────────────────── */
// document.addEventListener('click', async (e) => {
//   const atcBtn = e.target.closest('[data-add-to-cart], .add-to-cart, [name="add"]');
//   if (!atcBtn || !window.customerId) return;

//   // Resolve product ID from context
//   let productId =
//     atcBtn.closest('[data-product-id]')?.dataset.productId ||
//     atcBtn.closest('.product-card, [data-product-id]')
//       ?.querySelector('.wishlist-btn')?.dataset.productId;

//   if (!productId || !wishlistIds.includes(String(productId))) return;

//   await autoRemoveFromWishlist(productId);
// });

// /* ─────────────────────────────────────────────
//    Auto-remove from wishlist when added to cart
//    (fetch interception — catches all add-to-cart paths)
// ───────────────────────────────────────────── */
// (function interceptCartAdd() {
//   const originalFetch = window.fetch;

//   window.fetch = async function (...args) {
//     const response = await originalFetch.apply(this, args);
//     const urlStr   = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');

//     if (urlStr.includes('/cart/add')) {
//       try {
//         const data  = await response.clone().json();
//         const items = data.items || [data];

//         items.forEach(item => {
//           const productId = String(item.product_id);
//           if (wishlistIds.includes(productId) && window.customerId) {
//             autoRemoveFromWishlist(productId);
//           }
//         });
//       } catch (_) { /* non-JSON or unrelated response — ignore */ }
//     }

//     return response;
//   };
// })();

// /* ─────────────────────────────────────────────
//    Shared helper: silently remove product from wishlist
// ───────────────────────────────────────────── */
// async function autoRemoveFromWishlist(productId) {
//   try {
//     const data = await wishlistFetch({
//       customer_id: window.customerId,
//       product: { id: productId },
//       flag: true, // true = remove
//     });

//     if (data.success) {
//       syncLocalState(productId, true);
//       markWishlist();
//       bumpWishCount(productId, -1);
//     }
//   } catch (err) {
//     console.error('Auto-remove wishlist error:', err);
//   }
// }

// /* ─────────────────────────────────────────────
//    MutationObserver — re-mark hearts when new
//    cards are injected (infinite scroll, etc.)
// ───────────────────────────────────────────── */
// function observeWishlistButtons() {
//   const container = document.querySelector('main') || document.body;

//   new MutationObserver(mutations => {
//     const hasNew = mutations.some(m =>
//       [...m.addedNodes].some(node =>
//         node.nodeType === 1 &&
//         (node.matches?.('.wishlist-btn') || node.querySelector?.('.wishlist-btn'))
//       )
//     );
//     if (hasNew) {
//   markWishlist();
//   applyWishCounts();   
// }
//   }).observe(container, { childList: true, subtree: true });
// }

// /* ─────────────────────────────────────────────
//    Tooltip helpers
// ───────────────────────────────────────────── */
// function showTooltip(btn) {
//   removeTooltip(btn);

//   const tooltip = Object.assign(document.createElement('div'), {
//     className: 'wishlist-tooltip',
//     textContent: 'Move to Wishlist',
//   });
//   tooltip.style.cssText = `
//     position: absolute; bottom: calc(100% + 8px); left: 50%;
//     transform: translateX(-50%); background: #333; color: #fff;
//     padding: 5px 10px; border-radius: 4px; font-size: 12px;
//     white-space: nowrap; z-index: 9999; pointer-events: none;
//   `;

//   const arrow = document.createElement('div');
//   arrow.style.cssText = `
//     position: absolute; top: 100%; left: 50%;
//     transform: translateX(-50%);
//     border: 5px solid transparent; border-top-color: #333;
//   `;
//   tooltip.appendChild(arrow);

//   btn.style.position = 'relative';
//   btn.appendChild(tooltip);
// }

// function removeTooltip(btn) {
//   btn.querySelector('.wishlist-tooltip')?.remove();
// }

// /* ─────────────────────────────────────────────
//    Error toast
// ───────────────────────────────────────────── */
// function showErrorToast(message) {
//   document.querySelector('.wishlist-error-toast')?.remove();

//   const toast = document.createElement('div');
//   toast.className = 'wishlist-error-toast';
//   toast.style.cssText = `
//     position: fixed !important; top: 0 !important; left: 0 !important;
//     right: 0 !important; z-index: 2147483647 !important;
//     background: #fff0f0 !important; border-bottom: 1.5px solid #f5c6c6 !important;
//     padding: 14px 16px !important; box-shadow: 0 2px 12px rgba(0,0,0,.10) !important;
//     opacity: 0 !important; writing-mode: horizontal-tb !important;
//     direction: ltr !important; box-sizing: border-box !important;
//     overflow: hidden !important; transform: translateY(-100%) !important;
//     transition: opacity .3s ease, transform .3s ease !important;
//   `;

//   toast.innerHTML = `
//     <div style="display:table;width:100%;writing-mode:horizontal-tb;direction:ltr;">
//       <div style="display:table-cell;width:26px;vertical-align:middle;padding-right:10px;">
//         <div style="width:22px;height:22px;background:#e74c3c;border-radius:50%;text-align:center;line-height:22px;">
//           <span style="color:#fff;font-size:14px;font-weight:700;">&times;</span>
//         </div>
//       </div>
//       <div style="display:table-cell;vertical-align:middle;writing-mode:horizontal-tb;">
//         <p style="margin:0 0 2px;font-weight:700;color:#c0392b;font-size:14px;"></p>
//         <p style="margin:0;color:#c0392b;font-size:13px;line-height:1.4;">${message || 'Could not update wishlist'}</p>
//       </div>
//       <div style="display:table-cell;width:30px;vertical-align:middle;text-align:right;">
//         <button class="wishlist-toast-close" style="background:none;border:none;cursor:pointer;font-size:22px;color:#999;padding:0;line-height:1;">&times;</button>
//       </div>
//     </div>
//   `;

//   document.body.appendChild(toast);

//   // Animate in
//   requestAnimationFrame(() => {
//     toast.style.setProperty('opacity',   '1',          'important');
//     toast.style.setProperty('transform', 'translateY(0)', 'important');
//   });

//   function dismiss() {
//     toast.style.setProperty('opacity',   '0',             'important');
//     toast.style.setProperty('transform', 'translateY(-100%)', 'important');
//     setTimeout(() => toast.remove(), 300);
//   }

//   toast.querySelector('.wishlist-toast-close').addEventListener('click', dismiss);
//   setTimeout(dismiss, 5000);
// }

// /* ─────────────────────────────────────────────
//    Init
// ───────────────────────────────────────────── */
// window.markWishlist = markWishlist;
// document.addEventListener('DOMContentLoaded', () => {
//   loadWishlist();
//   observeWishlistButtons();
//   loadWishCounts(); 
// });


/* ─────────────────────────────────────────────
   Constants
───────────────────────────────────────────── */
/* ─────────────────────────────────────────────
   Constants
───────────────────────────────────────────── */
const WISHLIST_URL  = `https://dstugwafahsxviiqnceu.supabase.co/functions/v1/add-product-in-wishlist`;
const CACHE_KEY     = 'wishlist_ids';
var WISH_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRzdHVnd2FmYWhzeHZpaXFuY2V1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIxNjI5MzAsImV4cCI6MjA3NzczODkzMH0.9Sm1DjC5rZ6vQZGccPbVJUfKSKIvxe0UGgEFz6gRHr8';

/* ─────────────────────────────────────────────
   Icons (inline SVG — no Font Awesome CDN)
   data-icon-state is used by the click handler
   to detect the current state of a button
   instead of checking for an <i class="fa-solid">.
───────────────────────────────────────────── */
/* Theme's own icon font (no CDN needed — already used elsewhere in
   this theme as icon-cart, icon-circle, etc).
   ⚠️ CONFIRM: replace 'icon-heart' below with your theme's actual
   FILLED heart icon class if it's named differently
   (e.g. icon-heart-filled, icon-heart-solid). */
const HEART_ACTIVE_CLASS   = 'icon-heart';
const HEART_INACTIVE_CLASS = 'icon-heart-outline';

const ICON = {
  active:   `<i class="${HEART_ACTIVE_CLASS} wishlist-heart-icon" data-icon-state="active" aria-hidden="true"></i>`,
  inactive: `<i class="${HEART_INACTIVE_CLASS} wishlist-heart-icon" data-icon-state="inactive" aria-hidden="true"></i>`,
  loading:  `<span class="wishlist-spinner" data-icon-state="loading" aria-hidden="true"></span>`,
};

/* One-time CSS injection: a plain circular border spinner for the
   loading state (same visual style as .mobile-cart-spinner elsewhere
   in this theme) — no icon font / rotating glyph, no Font Awesome. */
(function injectWishlistIconStyles() {
  if (document.getElementById('wishlist-icon-style')) return;
  const style = document.createElement('style');
  style.id = 'wishlist-icon-style';
  style.textContent = `
    .wishlist-spinner {
      display: inline-block;
      width: 14px;
      height: 14px;
      border: 2px solid #f0c9c4;
      border-top-color: #e63312;
      border-radius: 50%;
      animation: wishlist-spin 0.7s linear infinite;
    }
    @keyframes wishlist-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
  `;
  document.head.appendChild(style);
})();

/* ─────────────────────────────────────────────
   State
───────────────────────────────────────────── */
let wishlistIds       = [];
const processingBtns  = new WeakSet(); // debounce: prevent double-clicks

/* ─────────────────────────────────────────────
   Cache helpers
───────────────────────────────────────────── */
function saveCache() {
  try { localStorage.setItem(CACHE_KEY, JSON.stringify(wishlistIds)); } catch (_) {}
}

function loadCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (raw) wishlistIds = JSON.parse(raw);
  } catch (_) {
    wishlistIds = [];
  }
}

/* ─────────────────────────────────────────────
   API helper  — single source of truth for fetch config
───────────────────────────────────────────── */
async function wishlistFetch(body) {
  const res = await fetch(WISHLIST_URL, {
    method:  'POST',
    headers: { 
      'Content-Type': 'application/json', 
      'Accept': 'application/json',
      'apikey': WISH_KEY, 'Authorization': 'Bearer ' + WISH_KEY 
     },
    body:    JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || 'Something went wrong');
  return data;
}

/* ─────────────────────────────────────────────
   Product data helper
───────────────────────────────────────────── */
function getProductFromBtn(btn) {
  return {
    id:     btn.dataset.productId    || '',
    title:  btn.dataset.productTitle || '',
    handle: btn.dataset.productHandle|| '',
    image:  btn.dataset.productImage || '',
    size:   btn.dataset.productSize  || '',
  };
}

/* ─────────────────────────────────────────────
   Wishlist count badge
───────────────────────────────────────────── */
function updateWishlistCount(count) {
  const el = document.getElementById('wishlist-count');
  if (el) el.textContent = Math.max(0, count);
}

/* ─────────────────────────────────────────────
   Mark all heart buttons active / inactive
───────────────────────────────────────────── */
function markWishlist() {
  const set = new Set(wishlistIds.map(String));

  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    if (btn.classList.contains('wishlist-cartitem')) return;
    btn.innerHTML = set.has(String(btn.dataset.productId))
      ? ICON.active
      : ICON.inactive;
  });

  updateWishlistCount(set.size);
}

/* ─────────────────────────────────────────────
   Load wishlist  (cache-first, then server)
───────────────────────────────────────────── */
async function loadWishlist() {
  if (!window.customerId) { markWishlist(); return; }

  // Step 1 — instant render from cache
  loadCache();
  markWishlist();

  // Step 2 — sync with server
  try {
    const data      = await wishlistFetch({ customer_id: window.customerId });
    const serverIds = (data.wishlistProducts?.data || []).map(p => String(p.product_id));

    // Only re-render if the lists actually differ (use copies to avoid mutating originals)
    const serverSorted  = [...serverIds].sort();
    const cachedSorted  = [...wishlistIds].sort();

    if (JSON.stringify(serverSorted) !== JSON.stringify(cachedSorted)) {
      wishlistIds = serverIds;
      saveCache();
      markWishlist();
    }
  } catch (err) {
    console.error('Wishlist load error:', err);
  }
}

/* ─────────────────────────────────────────────
   Sync wishlist state (add / remove ID)
───────────────────────────────────────────── */
function syncLocalState(productId, removing) {
  if (removing) {
    wishlistIds = wishlistIds.filter(id => id !== String(productId));
  } else if (!wishlistIds.includes(String(productId))) {
    wishlistIds.push(String(productId));
  }
  saveCache();
  updateWishlistCount(wishlistIds.length);
}

/* ─────────────────────────────────────────────
   Wish counts (public, per-product — how many
   customers in total have wishlisted a product)

   Rendered via the data-wishlist-count attribute
   on .wishlist-btn itself (CSS shows it with
   ::after { content: attr(data-wishlist-count) }),
   NOT as a child element — so it survives the
   innerHTML swaps in markWishlist()/click handler.
───────────────────────────────────────────── */
const wishCounts = {}; // productId (string) -> count

// Push cached counts onto every matching .wishlist-btn currently in the DOM
function applyWishCounts() {
  document.querySelectorAll('.wishlist-btn[data-product-id]').forEach(btn => {
    const id    = btn.dataset.productId;
    const count = wishCounts[id] || 0;
    btn.dataset.wishlistCount = count > 0 ? count : '';
  });
}

// Adjust a cached count immediately (optimistic UI) without waiting on a refetch
function bumpWishCount(productId, delta) {
  const id      = String(productId);
  const current = wishCounts[id] ?? 0;
  const next    = Math.max(0, current + delta);
  wishCounts[id] = next;

  document
    .querySelectorAll(`.wishlist-btn[data-product-id="${id}"]`)
    .forEach(btn => { btn.dataset.wishlistCount = next > 0 ? next : ''; });
}

// Edge function's GET method returns ALL product counts in one call:
// { success: true, data: [{ product_id, product_count }, ...] }
async function loadWishCounts() {
  try {
    const res  = await fetch(WISHLIST_URL, {
      method:  'GET',
      headers: {
         'Accept': 'application/json',
         'apikey': WISH_KEY, 'Authorization': 'Bearer ' + WISH_KEY 
         },
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || 'Something went wrong');

    (data.data || []).forEach(row => {
      wishCounts[String(row.product_id)] = Number(row.product_count) || 0;
    });

    applyWishCounts();
  } catch (err) {
    console.error('Wish counts load error:', err);
  }
}

/* ─────────────────────────────────────────────
   Wishlist page: animate & remove card
───────────────────────────────────────────── */
function removeCardFromWishlistPage(btn) {
  if (btn.closest('.wl-matches-grid')) return;
  const isWishlistPage =
    document.querySelector('.wishlist-page') ||
    document.querySelector('[id^="wishlist-section-"]');

  if (!isWishlistPage) return;

  const card = btn.closest('.product-card');
  if (!card) return;

  card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
  card.style.opacity    = '0';
  card.style.transform  = 'scale(0.95)';

  setTimeout(() => {
    card.remove();

    const grid = document.querySelector('[id^="wishlist-collection-"]');
    if (grid && grid.querySelectorAll('.product-card').length === 0) {
      grid.style.display = 'none';
      const empty = document.querySelector('[id^="wishlist-empty-"]');
      if (empty) empty.style.display = '';
    }
  }, 300);
}

/* ─────────────────────────────────────────────
   Cart item: move-to-wishlist flow
───────────────────────────────────────────── */
async function removeFromCart(btn, product) {
  const cartLineItem = btn.closest('li');
  const removeLink   = cartLineItem?.querySelector('.remove-from-cart-link');

  if (removeLink) {
    // Theme has a native remove link — show message, then click it
    const removedMsg = cartLineItem?.querySelector('.removed');
    const msgText    = cartLineItem?.querySelector('.removed-msg-text');

    if (removedMsg && msgText) {
      msgText.textContent    = `"${product.title}" moved to Wishlist`;
      removedMsg.style.display = 'block';
    }

    setTimeout(() => removeLink.click(), 600);
    return;
  }

  // Fallback: remove via /cart/change.js (returns updated cart — no second fetch needed)
  try {
    const cartData = await fetch('/cart.js').then(r => r.json());
    const cartItem = cartData.items.find(item => String(item.product_id) === String(product.id));

    if (cartItem) {
      const updatedCart = await fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: cartItem.key, quantity: 0 }),
      }).then(r => r.json());

      document.dispatchEvent(new CustomEvent('cart:refresh'));

      document
        .querySelectorAll('[data-cart-count], .cart-count, #cart-count, [data-totalqty]')
        .forEach(el => el.textContent = updatedCart.item_count);
    }
  } catch (err) {
    console.error('Cart remove error:', err);
  }
}

/* ─────────────────────────────────────────────
   Main click handler — wishlist buttons
───────────────────────────────────────────── */
// document.addEventListener('click', async (e) => {
//   const btn = e.target.closest('.wishlist-btn');
//   if (!btn) return;
document.addEventListener('click', async (e) => {
  const hit = e.target.closest('.wishlist-hitbox, .wishlist-btn');
  if (!hit) return;
  const btn = hit.classList.contains('wishlist-btn')
    ? hit
    : hit.querySelector('.wishlist-btn');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  // Auth guard
  if (!window.customerId) {
    window.location.href = `/account/login?return_url=https://account.circledrops.co`;
    return;
  }

  // Debounce: ignore while a request is in flight
  if (processingBtns.has(btn)) return;

  // Cart-item confirmation tooltip (first click = confirm, second click = proceed)
  if (btn.classList.contains('wishlist-cartitem')) {
    if (btn.dataset.confirmed !== 'true') {
      showTooltip(btn);
      btn.dataset.confirmed = 'true';
      setTimeout(() => { btn.dataset.confirmed = 'false'; removeTooltip(btn); }, 3000);
      return;
    }
    removeTooltip(btn);
    btn.dataset.confirmed = 'false';
  }

  // Capture state before we replace the icon
  // (was: btn.querySelector('i')?.classList.contains('fa-solid') — broke
  // once the icon stopped being a Font Awesome <i class="fa-solid ...">)
  const isRemoving = btn.querySelector('i, svg')?.dataset.iconState === 'active';
  const product    = getProductFromBtn(btn);

  btn.innerHTML = ICON.loading;
  processingBtns.add(btn);

  try {
    const data = await wishlistFetch({
      customer_id: window.customerId,
      product,
      flag: isRemoving,
    });

    if (!data.success) throw new Error('Unexpected response from server');

    btn.innerHTML = isRemoving ? ICON.inactive : ICON.active;
    syncLocalState(product.id, isRemoving);

    // Optimistically update the visible wish count for this product
    bumpWishCount(product.id, isRemoving ? -1 : 1);

    if (isRemoving) {
      removeCardFromWishlistPage(btn);
    } else {
      await removeFromCart(btn, product);
    }

  } catch (err) {
    // Restore previous icon on error
    btn.innerHTML = isRemoving ? ICON.active : ICON.inactive;
    showErrorToast(err.message || 'Could not update wishlist');
    console.error('Wishlist error:', err);
  } finally {
    processingBtns.delete(btn);
  }
});

/* ─────────────────────────────────────────────
   Auto-remove from wishlist when added to cart
   (click-level interception as a backup)
───────────────────────────────────────────── */
document.addEventListener('click', async (e) => {
  const atcBtn = e.target.closest('[data-add-to-cart], .add-to-cart, [name="add"]');
  if (!atcBtn || !window.customerId) return;

  // Resolve product ID from context
  let productId =
    atcBtn.closest('[data-product-id]')?.dataset.productId ||
    atcBtn.closest('.product-card, [data-product-id]')
      ?.querySelector('.wishlist-btn')?.dataset.productId;

  if (!productId || !wishlistIds.includes(String(productId))) return;

  await autoRemoveFromWishlist(productId);
});

/* ─────────────────────────────────────────────
   Auto-remove from wishlist when added to cart
   (fetch interception — catches all add-to-cart paths)
───────────────────────────────────────────── */
(function interceptCartAdd() {
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const urlStr   = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');

    if (urlStr.includes('/cart/add')) {
      try {
        const data  = await response.clone().json();
        const items = data.items || [data];

        items.forEach(item => {
          const productId = String(item.product_id);
          if (wishlistIds.includes(productId) && window.customerId) {
            autoRemoveFromWishlist(productId);
          }
        });
      } catch (_) { /* non-JSON or unrelated response — ignore */ }
    }

    return response;
  };
})();

/* ─────────────────────────────────────────────
   Shared helper: silently remove product from wishlist
───────────────────────────────────────────── */
async function autoRemoveFromWishlist(productId) {
  try {
    const data = await wishlistFetch({
      customer_id: window.customerId,
      product: { id: productId },
      flag: true, // true = remove
    });

    if (data.success) {
      syncLocalState(productId, true);
      markWishlist();
      bumpWishCount(productId, -1);
    }
  } catch (err) {
    console.error('Auto-remove wishlist error:', err);
  }
}

/* ─────────────────────────────────────────────
   MutationObserver — re-mark hearts when new
   cards are injected (infinite scroll, etc.)
───────────────────────────────────────────── */
function observeWishlistButtons() {
  const container = document.querySelector('main') || document.body;

  new MutationObserver(mutations => {
    const hasNew = mutations.some(m =>
      [...m.addedNodes].some(node =>
        node.nodeType === 1 &&
        (node.matches?.('.wishlist-btn') || node.querySelector?.('.wishlist-btn'))
      )
    );
    if (hasNew) {
  markWishlist();
  applyWishCounts();   
}
  }).observe(container, { childList: true, subtree: true });
}

/* ─────────────────────────────────────────────
   Tooltip helpers
───────────────────────────────────────────── */
function showTooltip(btn) {
  removeTooltip(btn);

  const tooltip = Object.assign(document.createElement('div'), {
    className: 'wishlist-tooltip',
    textContent: 'Move to Wishlist',
  });
  tooltip.style.cssText = `
    position: absolute; bottom: calc(100% + 8px); left: 50%;
    transform: translateX(-50%); background: #333; color: #fff;
    padding: 5px 10px; border-radius: 4px; font-size: 12px;
    white-space: nowrap; z-index: 9999; pointer-events: none;
  `;

  const arrow = document.createElement('div');
  arrow.style.cssText = `
    position: absolute; top: 100%; left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent; border-top-color: #333;
  `;
  tooltip.appendChild(arrow);

  btn.style.position = 'relative';
  btn.appendChild(tooltip);
}

function removeTooltip(btn) {
  btn.querySelector('.wishlist-tooltip')?.remove();
}

/* ─────────────────────────────────────────────
   Error toast
───────────────────────────────────────────── */
function showErrorToast(message) {
  document.querySelector('.wishlist-error-toast')?.remove();

  const toast = document.createElement('div');
  toast.className = 'wishlist-error-toast';
  toast.style.cssText = `
    position: fixed !important; top: 0 !important; left: 0 !important;
    right: 0 !important; z-index: 2147483647 !important;
    background: #fff0f0 !important; border-bottom: 1.5px solid #f5c6c6 !important;
    padding: 14px 16px !important; box-shadow: 0 2px 12px rgba(0,0,0,.10) !important;
    opacity: 0 !important; writing-mode: horizontal-tb !important;
    direction: ltr !important; box-sizing: border-box !important;
    overflow: hidden !important; transform: translateY(-100%) !important;
    transition: opacity .3s ease, transform .3s ease !important;
  `;

  toast.innerHTML = `
    <div style="display:table;width:100%;writing-mode:horizontal-tb;direction:ltr;">
      <div style="display:table-cell;width:26px;vertical-align:middle;padding-right:10px;">
        <div style="width:22px;height:22px;background:#e74c3c;border-radius:50%;text-align:center;line-height:22px;">
          <span style="color:#fff;font-size:14px;font-weight:700;">&times;</span>
        </div>
      </div>
      <div style="display:table-cell;vertical-align:middle;writing-mode:horizontal-tb;">
        <p style="margin:0 0 2px;font-weight:700;color:#c0392b;font-size:14px;"></p>
        <p style="margin:0;color:#c0392b;font-size:13px;line-height:1.4;">${message || 'Could not update wishlist'}</p>
      </div>
      <div style="display:table-cell;width:30px;vertical-align:middle;text-align:right;">
        <button class="wishlist-toast-close" style="background:none;border:none;cursor:pointer;font-size:22px;color:#999;padding:0;line-height:1;">&times;</button>
      </div>
    </div>
  `;

  document.body.appendChild(toast);

  // Animate in
  requestAnimationFrame(() => {
    toast.style.setProperty('opacity',   '1',          'important');
    toast.style.setProperty('transform', 'translateY(0)', 'important');
  });

  function dismiss() {
    toast.style.setProperty('opacity',   '0',             'important');
    toast.style.setProperty('transform', 'translateY(-100%)', 'important');
    setTimeout(() => toast.remove(), 300);
  }

  toast.querySelector('.wishlist-toast-close').addEventListener('click', dismiss);
  setTimeout(dismiss, 5000);
}

/* ─────────────────────────────────────────────
   Init
───────────────────────────────────────────── */
window.markWishlist = markWishlist;
document.addEventListener('DOMContentLoaded', () => {
  loadWishlist();
  observeWishlistButtons();
  loadWishCounts(); 
});